export * from './auth/auth';
export * from './global-service/global-service';
export * from './storage-service/storage-service';
export * from './user-service/user-service';
export * from './customer-service/customer-service';
export * from './http-service/http-service';
export * from './incident-service/incident-service';
export * from './new-order-service/new-order-service';
export * from './contact-service/contact-service';
export * from './videos-service/videos-service';
export * from './silos-service/silos-service';
export * from './settings-service/settings-service';
export * from './camera-service';
export * from './fb/fb';
export * from './ixom/ixom';
export * from './message-sevice/message-sevice';



// WEBPACK FOOTER //
// ./src/providers/index.ts